var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFivbLogoLarge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 24,
    viewBox: "0 0 64 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo fivb 1",
    clipPath: "url(#clip0_1173_23243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO FIVB BYLINE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1173_23243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -15,
    y: -14,
    width: 94,
    height: 52
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M78.224 -13.7629H-14.2217V37.7651H78.224V-13.7629Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1173_23243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1173_23243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -15,
    y: -14,
    width: 94,
    height: 52
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clip-path_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M78.224 -13.7629H-14.2217V37.7651H78.224V-13.7629Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1173_23243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.5192 0.5H26.2077V14.7651H22.5192V0.5ZM10.6685 5.78296H20.1504V8.95273H14.3526V14.7651H10.6663L10.6685 5.78296ZM21.2017 3.66977H10.6685V0.5H21.2017V3.66977ZM51.9268 7.45644C52.3581 7.13753 52.7099 6.72264 52.9544 6.24438C53.1989 5.76613 53.3295 5.23753 53.3359 4.70012C53.3359 2.07504 51.6192 0.50875 48.7553 0.50875H37.0965L34.3917 9.54775H34.3503L31.6455 0.5H27.523V3.66977H28.8426L32.5333 14.7651H36.2109L39.9016 3.66977H48.3452C49.4794 3.66977 49.6539 4.41573 49.6539 4.85762C49.6539 5.29951 49.486 6.04765 48.3452 6.04765H42.0196V9.21743H48.5153C49.6496 9.21743 49.8241 9.9612 49.8241 10.4053C49.8241 10.8493 49.6539 11.5953 48.5153 11.5953H42.0087V14.7651H49.0345C51.7632 14.7651 53.5256 13.0894 53.5256 10.495C53.5256 8.63991 52.5419 7.8502 51.9224 7.44769M32.0011 17.9348C20.5343 17.9348 9.68038 19.849 0 23.2637V23.5C10.4836 20.9998 21.2252 19.7515 32.0011 19.7811C42.777 19.7514 53.5186 20.9997 64.0022 23.5V23.2637C54.324 19.849 43.4679 17.9348 32.0011 17.9348ZM53.711 14.7607V13.5947H53.325V13.4394H54.2455V13.5947H53.8616V14.7607H53.711ZM54.3981 14.7607V13.4482H54.6294L54.9129 14.3844C54.9326 14.4719 54.9522 14.5376 54.9653 14.5769C54.9805 14.531 55.0002 14.4632 55.0285 14.3582L55.3121 13.4416H55.5171V14.7541H55.3601V13.6604L55.0154 14.7541H54.878L54.5421 13.6297V14.7541L54.3981 14.7607Z",
    fill: "#2732D4"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1173_23243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFivbLogoLarge);
export default __webpack_public_path__ + "static/media/fivb-logo-large.d01a652890a3c00a73c3d0ba619b9122.svg";
export { ForwardRef as ReactComponent };